import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=518d93e3"
import script from "./Selection.vue?vue&type=script&lang=ts"
export * from "./Selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports